import * as EVENTS from '../constants/external-events';
import { VISA } from '../constants/partnering-networks';
import hasSdkError from '../helpers/has-sdk-error';
import OrchCustomData from '../helpers/orch-custom-data';
import sendMessageToVisaSrci from '../helpers/send-message-to-visa-srci';
import updateDpaLocale from '../helpers/update-dpa-locale';

const getTimeStamps = lookUpResponseCache => {
  const result = {};
  const timeStamps = [];
  for (const network in lookUpResponseCache) {
    const networkData = lookUpResponseCache[network];
    if (networkData.data && networkData.data.consumerPresent) {
      result[networkData.timestamp] = network;
      timeStamps.push(networkData.timestamp);
    }
  }
  timeStamps.sort((a, b) => a - b);
  const fastestNetwork = result[timeStamps.shift()];
  return fastestNetwork;
};

const handleIdentityLookupPreference = () => {
  let otpProvider = '';
  const eventId = EVENTS.ORCH_IDENTITY_LOOKUP;
  let identityResponse;
  const lookUpResponseCache = OrchCustomData.srcSdks.apiResponseCache.identityLookUp;
  const orchConfig = OrchCustomData.srcSdks.orchConfig;
  const fallbackResponse = { consumerPresent: false };
  let isCustomerPresentinPreferredNtwk = false;
  let errorMsg;
  let hasNotPresent;
  // fastest network that gave consumerPresent true
  const fastestNetwork = getTimeStamps(lookUpResponseCache);
  if (fastestNetwork) {
    orchConfig.preferredNetwork = fastestNetwork;
    otpProvider = fastestNetwork;
    identityResponse = lookUpResponseCache[orchConfig.preferredNetwork].data;
    isCustomerPresentinPreferredNtwk = identityResponse && identityResponse.consumerPresent;
  }
  if (!identityResponse) {
    if (isCustomerPresentinPreferredNtwk) {
      identityResponse = lookUpResponseCache[orchConfig.preferredNetwork].data;
    } else {
      let error;
      // default to consumerPresent: false
      identityResponse = fallbackResponse;
      /*
       * if any consumerPresent: return that, else if any consumerPresent: false, return that.
       * Otherwise all errors, so send error
       */
      for (const val in lookUpResponseCache) {
        if (lookUpResponseCache[val]?.data?.consumerPresent) {
          identityResponse = { consumerPresent: true };
          break;
        } else if (lookUpResponseCache[val]?.data?.consumerPresent === false) {
          hasNotPresent = true;
        } else if (!error) {
          error = hasSdkError(lookUpResponseCache[val]);
          if (error) {
            errorMsg = error;
          }
        }
      }
      // if all the responses in the cache are errors, attempt to get the Visa error message
      if (!identityResponse.consumerPresent && !hasNotPresent && errorMsg) {
        const visaError = hasSdkError(lookUpResponseCache[VISA]);
        if (visaError) {
          identityResponse = { error: { reason: visaError } };
        } else {
          identityResponse = { error: { reason: errorMsg } };
        }
      }
    }
  }
  identityResponse.otpProvider = otpProvider;
  if (identityResponse.consumerPresent && lookUpResponseCache[VISA]?.data?.consumerPresent) {
    identityResponse.customData = lookUpResponseCache[VISA]?.data?.customData;
    const dpaLocale = OrchCustomData?.srcSdks?.orchConfig?.dpaLocale;
    /* app expects locale as xx-YY (eg: en-US) format, makesure dpaLocale is in xx-YY format.
        * reason: all our language reference(translation file) is with /xx-YY/*
        */
    const defaultLocale = dpaLocale ? dpaLocale.replace('_', '-') : null;
    const locality = identityResponse.customData?.data?.data?.locality;
    const locale = locality?.locale ?? defaultLocale;
    const initData = OrchCustomData.initData;
    for (const network in initData) {
      if (network !== VISA) {
        updateDpaLocale(initData[network], locale);
      }
    }
  }
  sendMessageToVisaSrci(eventId, identityResponse);
  // to resolve V.identityLookup for VSB flow. Based on VSB spec
  if (identityResponse.error) {
    return { error: identityResponse.error };
  }
  return { consumerPresent: identityResponse.consumerPresent };
};

export default handleIdentityLookupPreference;
